export default {
  title: {
    id: 'companies.title',
    defaultMessage: 'Companies',
  },
  all: {
    id: 'companies.all',
    defaultMessage: 'All',
  },
  activity: {
    id: 'companies.activity',
    defaultMessage: 'Activity',
  },
  active: {
    id: 'companies.active',
    defaultMessage: 'Active',
  },
  addCompany: {
    id: 'companies.addCompany',
    defaultMessage: 'Add company',
  },
  export: {
    id: 'companies.export',
    defaultMessage: 'Export to CSV…',
  },
  exportCompanies: {
    id: 'companies.exportCompanies',
    defaultMessage: 'Companies',
  },
  exportClients: {
    id: 'companies.exportClients',
    defaultMessage: 'Clients',
  },
  search: {
    id: 'companies.search',
    defaultMessage: 'Search…',
  },
  empty: {
    id: 'companies.empty',
    defaultMessage: 'No companies meet the selected criteria.',
  },
  id: {
    id: 'companies.id',
    defaultMessage: 'ID',
  },
  name: {
    id: 'companies.company',
    defaultMessage: 'Company',
  },
  site: {
    id: 'companies.website',
    defaultMessage: 'Website',
  },
  paid_till: {
    id: 'companies.paidTill',
    defaultMessage: 'Paid till',
  },
  max_number_employees: {
    id: 'companies.employees',
    defaultMessage: 'Employees number',
  },
  account_manager__first_name: {
    id: 'companies.accountManager',
    defaultMessage: 'Account Manager',
  },
  inactive: {
    id: 'companies.inactive',
    defaultMessage: 'inactive',
  },
  noName: {
    id: 'companies.noName',
    defaultMessage: 'No name',
  },
};
